<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal
    :title="'存储记录'"
    :width="1300"
    :open="true"
    :confirmLoading="state.loading"
    :maskClosable="false"
    @ok="onFormSubmit"
    @cancel="
      () => {
        emit('cancel')
      }
    "
    ><a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row :gutter="48">
            <a-col :md="3" :sm="24">
              <a-form-item label="库位编号">
                <a-input v-model:value="queryParam.code" placeholder="请输入库位编号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="主体名称">
                <a-input v-model:value="queryParam.full_name" placeholder="请输入主体名称"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="状态" name="status">
                <a-select mode="multiple" v-model:value="queryParam.status" placeholder="请选择">
                  <a-select-option :value="1">待存</a-select-option>
                  <a-select-option :value="2">已存</a-select-option>
                  <a-select-option :value="3">待取</a-select-option>
                  <a-select-option :value="4">已取</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间" name="between_time">
                <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime" @change="rangTimeChange" :format="format"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="3" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="loadData">查询</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination" @change="onChange" rowKey="id">
        <template #bodyCell="{ column, record, index, text }">
          <template v-if="column.dataIndex == 'status'">
            <a-tag v-if="record.status == 1" color="pink">待存</a-tag>
            <a-tag v-else-if="record.status == 2" color="green">已存</a-tag>
            <a-tag v-else-if="record.status == 3" color="blue">待取</a-tag>
            <a-tag v-else-if="record.status == 4" color="gray">已取</a-tag>
            <a-tag v-else>{{ text }}</a-tag>
          </template>
        </template>
      </a-table>
    </a-card>
  </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'
const props = defineProps({
  detailData: {
    type: Object,
    default: () => null
  }
})
const emit = defineEmits(['cancel'])
const columns = [
  {
    title: '库位编号',
    dataIndex: 'code',
    width: 100
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 100
  },
  {
    title: '主体名称',
    dataIndex: 'full_name',
    width: 300
  },
  {
    title: '操作人',
    dataIndex: 'operator_admin',
    width: 200
  },
  {
    title: '存入时间',
    dataIndex: 'push_time',
    width: 200
  },
  {
    title: '取出时间',
    dataIndex: 'pop_time',
    width: 200
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: 200
  }
]
interface state {
  loading: boolean
  detailData: object
  detailVisible: boolean
}
const state = reactive<state>({
  loading: false,
  detailData: {},
  detailVisible: false
})
let queryParam = reactive<any>({
  remark: ''
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
  current: 1,
  total: undefined,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: (total) => `总数：${total}`
})
onMounted(() => {
  queryParam.code = props.detailData.code
  loadData()
})
// 时间选择
const rangTime = computed(() => {
  let array: any = []
  if (queryParam.between_time) {
    array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
  } else {
    array = []
  }
  return array
})
// 时间选择
const rangTimeChange = (val, str) => {
  if (val) {
    queryParam.between_time = str.join(',')
  } else {
    queryParam.between_time = null
  }
}
const loadData = () => {
  state.loading = true
  // 获取到列表数据
  let requestParam = {
    url: '/admin/v1/storeCang/recordList',
    method: 'post',
    data: Object.assign({ page: pagination.current, limit: pagination.pageSize, store_id: props.detailData.store_id }, queryParam)
  }
  baseService(requestParam).then((res) => {
    state.loading = false
    pagination.total = res.data.total_records
    dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
  })
}
const onChange = (val) => {
  pagination.pageSize = val.pageSize
  pagination.current = val.current
  loadData()
}
const onFormSubmit = () => {
  emit('cancel')
}
const handleRecord = (record) => {
  state.detailVisible = true
  state.detailData = { ...record }
}
const cancel = () => {
  state.detailVisible = false
}
</script>
<style lang="less" scoped></style>
